import { purchaseModelCode } from '@otovo/shared/cloudEnums';
import {
  Sanity$ProductSectionDisplayType,
  Sanity$TextBlock,
} from '@otovo/shared/types/sanityTypes';
import cx from 'classnames';
import CustomHeading from '../CustomHeading';
import PriceRowSwitcher from './PriceRowSwitcher';

type Props = {
  heading: Sanity$TextBlock[];
  description: string;
  setDisplaySubscriptionPrice: React.Dispatch<React.SetStateAction<boolean>>;
  displaySubscriptionPrice: boolean;
  productSectionDisplayType: Sanity$ProductSectionDisplayType;
  subscriptionText: string;
  buyNowText: string;
};

const PriceRowHeading = ({
  heading,
  description,
  setDisplaySubscriptionPrice,
  displaySubscriptionPrice,
  productSectionDisplayType,
  subscriptionText,
  buyNowText,
}: Props) => {
  const showPriceRowSwitcher =
    productSectionDisplayType !== purchaseModelCode.BUY_NOW &&
    productSectionDisplayType !== purchaseModelCode.LEASING;

  const headingStyles =
    'text-lilac-20 mb-4 text-2xl font-medium md:text-3xl xl:text-4xl';

  return (
    <div className="grid grid-cols-5 p-8 md:py-20">
      <div
        className={cx(
          'col-span-full',
          `${showPriceRowSwitcher && 'lg:col-span-3'}`,
        )}
      >
        <CustomHeading heading={heading} headingStyles={headingStyles} />

        <p className="text-base text-lilac-30 md:text-lg">{description}</p>
      </div>
      {showPriceRowSwitcher && (
        <div className="col-span-full my-4 lg:col-span-2 lg:m-0 lg:flex lg:justify-end lg:self-end">
          <PriceRowSwitcher
            setDisplaySubscriptionPrice={setDisplaySubscriptionPrice}
            displaySubscriptionPrice={displaySubscriptionPrice}
            buyNowText={buyNowText}
            subscriptionText={subscriptionText}
          />
        </div>
      )}
    </div>
  );
};
export default PriceRowHeading;
